import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _checkQuotaRequest = {};
var _checkQuotaResponse = {};
var _getQuotaRequest = {};
var _getQuotaResponse = { package: '_package' };
var _package = {
    subscriptionTime: 'google.protobuf.Timestamp',
    cycleTime: 'google.protobuf.Timestamp',
    expirationTime: 'google.protobuf.Timestamp',
    date: 'google.protobuf.Timestamp',
};
var _resetQuotaRequest = {};
var _resetQuotaResponse = {};
function resolveWixInnovationAssistantQuotaV1WixAssistantQuotaUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
            {
                srcPath: '/_api',
                destPath: '/api',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/wix-assistant-quota',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-assistant-quota',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get the quota for the site. */
export function getQuota(payload) {
    var _a = serializer(_getQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuotaResponse, { _package: _package }).fromJSON;
    function __getQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.assistant.v1.quota',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.quota.v1.WixAssistantQuota.GetQuota',
            url: resolveWixInnovationAssistantQuotaV1WixAssistantQuotaUrl({
                protoPath: '/v1/quota',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getQuota.fromReq = fromReq;
    __getQuota.__isAmbassador = true;
    return __getQuota;
}
/** Get the quota for the site. */
export function checkQuota(payload) {
    var _a = serializer(_checkQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkQuotaResponse, {}).fromJSON;
    function __checkQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.assistant.v1.quota',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.quota.v1.WixAssistantQuota.CheckQuota',
            url: resolveWixInnovationAssistantQuotaV1WixAssistantQuotaUrl({
                protoPath: '/v1/quota/check',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkQuota.fromReq = fromReq;
    __checkQuota.__isAmbassador = true;
    return __checkQuota;
}
/** Reset the quota for the site. */
export function resetQuota(payload) {
    var _a = serializer(_resetQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resetQuotaResponse, {}).fromJSON;
    function __resetQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.assistant.v1.quota',
            method: 'PUT',
            methodFqn: 'wix.innovation.assistant.quota.v1.WixAssistantQuota.ResetQuota',
            url: resolveWixInnovationAssistantQuotaV1WixAssistantQuotaUrl({
                protoPath: '/v1/quota/reset',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resetQuota.fromReq = fromReq;
    __resetQuota.__isAmbassador = true;
    return __resetQuota;
}
//# sourceMappingURL=http.impl.js.map